export default function Card(theme) {
    return {
        MuiCard: {
            styleOverrides: {
                root: {
                    borderRadius: theme.shape.customBorderRadius[4],
                    border: `1px solid ${theme.palette.primary.greyThread}`,
                    boxShadow: 'none',
                },
            },
        },
    }
}